import styled from '@emotion/styled';
import { mediaQueries } from '../../../style/global-style';
import { StyledButton } from '../../atoms/dreamlines-button/dreamlines-button.style';

export const StyledSubpageSticky = styled.div`
    background-color: #ffffff;
    padding: 10px 6px;
    border-bottom: 2px solid ${(props) => props.theme.colorsUnifications.whiteSmoke[100]};

    @media ${mediaQueries.tabletAndUp} {
        padding: 16px 0;
    }

    .container {
        display: flex;
        align-items: center;
    }

    ${StyledButton} {
        @media ${mediaQueries.tabletAndUp} {
            padding-top: 20px;
            padding-bottom: 20px;
            padding-left: 20px;
        }
    }
`;
